import AttachmentsPageContainer from './containers/AttachmentsPageContainer'
export default AttachmentsPageContainer
